module.exports = __webpack_public_path__ + "static/img/short20.c8378b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/short20.png
// module id = 8aLN
// module chunks = 0